import { list } from './list';

export type { ConfigurationChangelogListQuery } from './list';

export const configurationChangelog = {
  list,
};
